module.exports = __webpack_public_path__ + "static/img/c14.d3f9370.png";


//////////////////
// WEBPACK FOOTER
// ./static/hotpages/promo-vale-pedagio/c14.png
// module id = 1852
// module chunks = 1